import { League } from '../models';
import { LeagueRepository, TournamentRepository } from '../repositories';

export class CompleteLeagueUseCase {
  constructor(
    private leagueRepository: LeagueRepository,
    private tournamentRepository: TournamentRepository
  ) {}

  async execute(leagueId: string): Promise<League> {
    const league = await this.leagueRepository.getById(leagueId);
    if (!league) {
      throw new Error('League not found');
    }

    if (league.status !== 'active') {
      throw new Error('Only active leagues can be completed');
    }

    // Verify all league tournaments are completed
    const allTournaments = await this.tournamentRepository.getAll(1000, 0);
    const leagueTournaments = allTournaments.filter(t => t.leagueId === leagueId);

    if (leagueTournaments.length === 0) {
      throw new Error('League has no tournaments');
    }

    const incompleteCount = leagueTournaments.filter(t => t.status !== 'completed').length;
    if (incompleteCount > 0) {
      throw new Error('All tournaments must be completed before the league can be completed');
    }

    return await this.leagueRepository.update(leagueId, { status: 'completed' });
  }
}
